import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
const initialState = {
  widths: {}
};
const widthsSlice = createSlice({
  name: 'widths',
  initialState,
  reducers: {
    setAllWidths: (state, action) => {
      state.widths = action.payload;
    },
    setWidth: (state, {
      payload: {
        columnKey,
        width
      }
    }) => {
      state.widths[columnKey] = width;
    }
  }
});
export const widthsReducer = widthsSlice.reducer;
export const {
  setAllWidths,
  setWidth
} = widthsSlice.actions;

const getWidths = ({
  widths: {
    widths
  }
}) => widths;

export const getTableMinWidth = createSelector([getWidths], widths => Object.values(widths).reduce((sum, width) => sum + width, 0));
export const makeGetColumnWidth = columnKey => createSelector([getWidths], widths => widths[columnKey]);